import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function SimStore() {
  const selectedPackageType = "Premium";
  const packageType = "voicedata";
  const role = "Partner";

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="p-4">
      <table className="w-full rounded-lg shadow-lg bg-white">
        <thead className="sticky top-0 bg-gray-200">
          <tr className="border-b">
            <th className="text-center p-3">Country/Region</th>
            <th className="text-center p-3">Data</th>
            <th className="text-center p-3">Validity</th>

            {selectedPackageType === "Premium" &&
              packageType === "voicedata" && (
                <th className="text-center p-3">Voice</th>
              )}

            <th className="text-center p-3">Plan Code</th>

            {role === "Partner" && (
              <th className="text-center p-3">Price</th>
            )}

            {selectedPackageType === "Premium" && (
              <th className="text-center p-3">Renewal</th>
            )}

            <th className="text-center p-3">Operator</th>
            <th className="text-center p-3">Add to Cart</th>
            <th className="text-center p-3">Details</th>
          </tr>
        </thead>

        <tbody>
          {/* Row 1 */}
          <tr className="border-b hover:bg-gray-100">
            <td className="text-center p-2">
              <div className="flex justify-start ml-8 items-center">
                <img
                  src="https://www.airhubapp.jp/assets/flags/USA.svg"
                  alt="USA"
                  className="w-8 h-8 mr-2"
                />
                <span>USA</span>
              </div>
            </td>

            <td className="text-center p-2">100GB</td>
            <td className="text-center p-2">30 Days</td>

            {selectedPackageType === "Premium" &&
              packageType === "voicedata" && (
                <td className="text-center p-2">Unlimited Calls</td>
              )}

            <td className="text-center p-2">121786</td>

            {role === "Partner" && (
              <td className="text-center p-2">$30</td>
            )}

            {selectedPackageType === "Premium" && (
              <td className="text-center p-2">Auto</td>
            )}

            <td className="text-center p-2">PWG</td>

            <td className="text-center p-2">
              <button className="rounded-2xl px-3 py-2 border-2 text-[#3E436D]">
                Add to cart
              </button>
            </td>

            <td className="text-center p-2">
              <button
                onClick={() => setShowModal(true)}
                className="rounded-lg bg-[#3E436D] p-2 text-white"
              >
                View Details
              </button>
            </td>
          </tr>

          {/* Row 2 */}
          <tr className="border-b hover:bg-gray-100">
            <td className="text-center p-2">
              <div className="flex justify-start ml-8 items-center">
                <img
                  src="https://www.airhubapp.jp/assets/flags/UK.svg"
                  alt="UK"
                  className="w-8 h-8 mr-2"
                />
                <span>United Kingdom</span>
              </div>
            </td>

            <td className="text-center p-2">50GB</td>
            <td className="text-center p-2">15 Days</td>

            {selectedPackageType === "Premium" &&
              packageType === "voicedata" && (
                <td className="text-center p-2">500 Minutes</td>
              )}

            <td className="text-center p-2">987654</td>

            {role === "Partner" && (
              <td className="text-center p-2">$20</td>
            )}

            {selectedPackageType === "Premium" && (
              <td className="text-center p-2">Manual</td>
            )}

            <td className="text-center p-2">Vodafone</td>

            <td className="text-center p-2">
              <button className="rounded-2xl px-3 py-2 border-2 text-[#3E436D]">
                Add to cart
              </button>
            </td>

            <td className="text-center p-2">
              <button className="rounded-lg bg-[#3E436D] p-2 text-white">
                View Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white w-[700px] rounded-xl shadow-lg overflow-hidden">

            {/* Header */}
            <div className="bg-[#3E436D] text-white p-4 relative text-center">
              <button
                onClick={() => setShowModal(false)}
                className="absolute right-4 top-2 text-xl"
              >
                ✕
              </button>

              <h2 className="text-lg font-semibold">USA SIM Plan</h2>
              <p className="text-sm">Stay connected worldwide</p>

              <div className="flex justify-around mt-4">
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">100 GB</p>
                  <p className="text-xs">Data</p>
                </div>
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">30 Days</p>
                  <p className="text-xs">Validity</p>
                </div>
                <div className="bg-white/20 px-4 py-2 rounded">
                  <p className="font-bold">1</p>
                  <p className="text-xs">Countries</p>
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex justify-around p-3 border-b text-sm">
              <button className="font-semibold text-[#3E436D]">
                Overview
              </button>
              <button className="text-gray-500">Features</button>
              <button className="text-gray-500">More Information</button>
            </div>

            {/* Content */}
            <div className="p-4 grid grid-cols-2 gap-4 text-sm">
              <div className="bg-gray-100 p-3 rounded">
                <p className="font-semibold">Plan Coverage</p>
                <p>Local</p>
              </div>

              <div className="bg-gray-100 p-3 rounded">
                <p className="font-semibold">Plan Type</p>
                <p>voicedata</p>
              </div>

              <div className="bg-gray-100 p-3 rounded">
                <p className="font-semibold">Network Configuration</p>
                <p>Operator: T-Mobile</p>
                <p>APN: fast.tmobile.com</p>
                <p>Network: 4G/5G</p>
              </div>

              <div className="bg-gray-100 p-3 rounded">
                <p className="font-semibold">Plan Information</p>
                <p>Plan Code: 4128283</p>
                <p>Activation: SIM Provision</p>
                <p>Device: iOS & Android</p>
              </div>
            </div>

            {/* Bottom Actions */}
            <div className="p-4 flex flex-col items-center gap-3">
              <div className="flex gap-4">
                <button className="border px-4 py-2 rounded-full">
                  ESN/SIM
                </button>
                <button className="border px-4 py-2 rounded-full">
                  Enter Zip Code
                </button>
              </div>

              {/* Content */}
            <div className="p-4 text-center">
              <button
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setLoading(false);
                    setShowModal(false);
                    setSuccess(true);
                  }, 2000);
                }}
                className="bg-[#3E436D] text-white px-6 py-2 rounded-full w-full"
              >
                {loading ? "Processing..." : "Buy Now - $52.00"}
              </button>
            </div>
          </div>
        
          </div>
          </div>

      )}

      {/* Success Modal */}
      {success && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-[300px]">
            <h2 className="text-lg font-semibold mb-4">
              SIM purchased successfully 🎉
            </h2>

            <button
              onClick={() => {
                setSuccess(false);
                navigate("/SimMangement");
              }}
              className="bg-[#3E436D] text-white px-6 py-2 rounded"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SimStore;